import * as jwtDecode from 'jwt-decode';
import { TipoPerfilUsuarioEnum } from '../enums';
import { isEmail } from './validation';

export const isContratante = (role) => {
  const Contratante = {
    ContratanteAlteracao:
      TipoPerfilUsuarioEnum.returnNameForName.ContratanteAlteracao,
    ContratanteConsulta:
      TipoPerfilUsuarioEnum.returnNameForName.ContratanteConsulta,
  };

  return Object.values(Contratante).includes(role);
};

export const isAdmin = (role) => {
  const Administrador = {
    Adm: TipoPerfilUsuarioEnum.returnNameForName.Adm,
  };

  return Object.values(Administrador).includes(role);
};

export const isContratanteNestle = (user) => {
  const { role } = user;
  const ContratanteNestle = {
    ContratanteAlteracao:
      TipoPerfilUsuarioEnum.returnNameForName.ContratanteAlteracao,
    ContratanteConsulta:
      TipoPerfilUsuarioEnum.returnNameForName.ContratanteConsulta,
  };
  const contratanteNestle =
    user.hasOwnProperty('GrupoContratante') &&
    /nestle/gi.test(user.GrupoContratante);

  return Object.values(ContratanteNestle).includes(role) && contratanteNestle;
};

const isLegacyUser = (nameid) => {
  return !isEmail(nameid);
};

export const isOldAdmin = (accessToken) => {
  const { role, nameid } = jwtDecode(accessToken);

  const ROLE_E_NAMEID_VALIDOS = role && nameid;
  return ROLE_E_NAMEID_VALIDOS && isAdmin(role) && isLegacyUser(nameid);
};
